export default __webpack_public_path__ + "static/media/DeerFiction.25ffccdd.png";